import { render } from "./TopNavItem.vue?vue&type=template&id=f1a5801e"
import script from "./TopNavItem.vue?vue&type=script&lang=js"
export * from "./TopNavItem.vue?vue&type=script&lang=js"

import "../styles/TopNavItem.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__